// src/pages/Gallery.jsx
import { useState } from 'react';
import { Link } from 'react-router-dom';
import team from '../Assets/TeamandOthers/Team.webp'
import clinic1 from '../Assets/TeamandOthers/Interiorimg.webp'
import clinic2 from '../Assets/TeamandOthers/clinic1.webp'
import clinic3 from '../Assets/TeamandOthers/clinic3.webp'
import clinic4 from '../Assets/TeamandOthers/clinic4.webp'

import reception from '../Assets/TeamandOthers/Reception.webp'
import beforeAfter1 from '../Assets/TeamandOthers/before_after1-2.webp'
import beforeAfter2 from '../Assets/TeamandOthers/before_after2.webp'
import Awardimg1 from '../Assets/Awards/Picture7.webp'
import Awardimg2 from '../Assets/Awards/Awardimg2.webp'
import Awardimg3 from '../Assets/Awards/Picture3.webp'
import Awardimg4 from '../Assets/Awards/Awardimg6.jpg'
import Awardimg5 from '../Assets/Awards/Awardimg5.jpg'
import Awardimg6 from '../Assets/Awards/Awardimg8.jpg'
import Awardimg7 from '../Assets/Awards/Awardimg7.jpg'
import Awardimg8 from '../Assets/Awards/Awardimg3.webp'
import Awardimg9 from '../Assets/Awards/Awardimg9.webp'
import Awardimg10 from '../Assets/Awards/Awardimg10.webp'
import Awardimg11 from '../Assets/Awards/Awardimg11.webp'
import Awardimg12 from '../Assets/Awards/Awardimg12.webp'

import team2 from '../Assets/TeamandOthers/Team2.webp'
import team3 from '../Assets/TeamandOthers/Team3-1.webp'
import team4 from '../Assets/TeamandOthers/Team4.webp'
import team5 from '../Assets/TeamandOthers/Team5.webp'
import team6 from '../Assets/TeamandOthers/Team6.webp'
import team7 from '../Assets/TeamandOthers/Team7.webp'
import team8 from '../Assets/TeamandOthers/Team8.webp'
import team9 from '../Assets/TeamandOthers/Team11-1.webp'
import team10 from '../Assets/TeamandOthers/Team10.webp'
import team11 from '../Assets/TeamandOthers/Team11.webp'
import treatementsimg1 from '../Assets/Services/Treatments1.webp'
import treatementsimg2 from '../Assets/Services/Treatments2-1.webp'
import treatementsimg3 from '../Assets/Services/Treatments3.webp'
import treatementsimg4 from '../Assets/Services/Treatments4.webp'
import treatementsimg5 from '../Assets/Services/Treatments5.webp'
import treatementsimg6 from '../Assets/Services/Treatments7.webp'

import Certificate1 from '../Assets/Certificates/Certificate1.webp'
import Certificate2 from '../Assets/Certificates/Certificate2.webp'
import Certificate3 from '../Assets/Certificates/Certificate3.webp'
import Certificate4 from '../Assets/Certificates/Certificate4.webp'
import Certificate5 from '../Assets/Certificates/Certificate5.jpg'
import Certificate6 from '../Assets/Certificates/Certificate6.webp'
import Certificate7 from '../Assets/Certificates/Certificate7.webp'
import Certificate8 from '../Assets/Certificates/Certificate8.jpg'
import Certificate9 from '../Assets/Certificates/Certificate9.webp'
import Certificate10 from '../Assets/Certificates/Certificate10.webp'
import Certificate11 from '../Assets/Certificates/Certificate11.webp'
import Pressclicks1 from '../Assets/TeamandOthers/Pressclick1.webp'
import Pressclicks2 from '../Assets/TeamandOthers/Pressclick2.jpg'
import Pressclicks3 from '../Assets/TeamandOthers/Pressclick3.jpg'
import Pressclicks4 from '../Assets/TeamandOthers/Pressclick4.webp'
import Pressclicks5 from '../Assets/TeamandOthers/Pressclick5.webp'
import Pressclicks6 from '../Assets/TeamandOthers/Pressclick6.webp'
import Pressclicks7 from '../Assets/TeamandOthers/Pressclick7.webp'
import Pressclicks8 from '../Assets/TeamandOthers/Pressclick8.webp'


// Mock gallery data (replace with your real images later)
const galleryItems = [
  {
    id: 1,
    title: "Modern Clinic Interior",
    category: "Clinic",
    image: clinic1,
    description: "State-of-the-art treatment room with advanced equipment",
  },
  {
    id: 2,
    title: "Before & After – Smile Makeover",
    category: "Before/After",
    image: beforeAfter1,
    description: "Cosmetic transformation with veneers and whitening",
  },
  {
    id: 3,
    title: "Ugadi Puraskar",
    category: "Awards",
    image: Awardimg1,
    description: "Dr. Sridhar received excellence award from the Hon’ble Chief Minister of Andhra Pradesh Sri.N.Chandra Babu Naidu",
  },
  // {
  //   id: 4,
  //   title: "Happy Young Patient",
  //   category: "Pediatric",
  //   image: team,
  //   description: "Child enjoying a fun dental visit",
  // },
  {
    id: 5,
    title: "Dental Team",
    category: "Team",
    image: team,
    description: "Our expert dentists and support staff",
  },
  {
    id: 6,
    title: "Laser Treatment in Progress",
    category: "Treatments",
    image: treatementsimg1,
    description: "Painless laser gum reshaping procedure",
  },
  {
    id: 7,
    title: "Implant Surgery Setup",
    category: "Treatments",
    image: treatementsimg2,
    description: "Advanced implant placement environment",
  },
  {
    id: 8,
    title: "Reception & Waiting Area",
    category: "Clinic",
    image: reception,
    description: "Comfortable and welcoming reception",
  },
  {
    id: 9,
    title: "Before & After – Implants",
    category: "Before/After",
    image: beforeAfter2,
    description: "Full mouth rehabilitation with implants",
  },
  {
    id: 10,
    title: "National Child Welfare Award",
    category: "Awards",
    image: Awardimg9,
    description: "Dr. Sridhar Received “National Child Welfare Award” from Sri. Ramnath Kovind, Hon’ble President of India on 22-01-2019",
  },
  {
    id: 11,
    title: "Congratulating for receiving “National Child Welfare Award”",
    category: "Awards",
    image: Awardimg10,
    description: "Prime Minister of India Hon’ble Sri.Narendra Modi congratulating Dr.A.Sridhar Reddy for receiving “National Child Welfare Award” at New Delhi on 23-01-2019.",
  },
  {
    id: 12,
    title: "Gold Medal ",
    category: "Awards",
    image: Awardimg11,
    description: "Dr. Sridhar Received Gold Medal from Sri. Pranab Mukherjee, Hon’ble President of India on 30-08-2016 for the Humanitarian Service through Red Cross at Rashtrapati Bhavan.",
  },
  {
    id: 13,
    title: "NTR Trust Award",
    category: "Awards",
    image: Awardimg12,
    description: "Dr. Sridhar Received Prestigious “NTR Trust Award” from His Excellency Governor of Andhra Pradesh and Sri. N.Chandra Babu Naidu Chief Minister of Andhra Pradesh.",
  },
  {
    id: 14,
    title: "Certificate of Merit",
    category: "Awards",
    image: Awardimg2,
    description: "Dr. Sridhar received from Sri. J.P. Nadda Hon’ble Minister for Health, Govt. of India",
  },
  {
    id: 15,
    title: "Gold Medal",
    category: "Awards",
    image: Awardimg3,
    description: "Dr. Sridhar received from Sri. E.S.L. Narasimhan, Governor of Andhra Pradesh .",
  },
  {
    id: 16,
    title: "Meritorious Certificate ",
    category: "Awards",
    image: Awardimg6,
    description: "Dr. Sridhar received from Sri.BR Meena IAS District Collector, Krishna in 1998.",

  },
  {
    id: 17,
    title: "Trophy(RED CROSS)",
    category: "Awards",
    image: Awardimg5,
    description: "Dr. Sridhar Received Trophy along with the District Collector Sri.Navin Mittal IAS from His Excellency Governor of Andhra Pradesh Sri.N.D. Tiwari for the Best District  (RED CROSS) Branch in 2008.",
  },
  {
    id: 18,
    title: "OUTSTANDING DENTIST AWARD ",
    category: "Awards",
    image: Awardimg4,
    description: "Dr. Sridhar Received MOST COMMENDABLE OUTSTANDING DENTIST AWARD - 2017",
  },
  {
    id: 19,
    title: "OUTSTANDING DENTIST OF THE YEAR ",
    category: "Awards",
    image: Awardimg7,
    description: "Dr. Sridhar Received ‘OUTSTANDING DENTIST OF THE YEAR – 2014’ from Dr.Arun Jamakar, Vice – Chancellor, Maharashtra Heath University.",
  },
  {
    id: 20,
    title: "Seva Medal",
    category: "Awards",
    image: Awardimg8,
    description: "Dr. Sridhar Received  Seva Medal from His Excellency Governor of Andhra Pradesh Sri. E.S.L. Narasimhan.",
  },
  {
  id: 21,
  title: "Experienced Dental Professional",
  category: "Team",
  image: team2,
  description: "Committed to delivering exceptional dental care with professionalism and attention to detail."
},
{
  id: 22,
  title: "Dedicated Dental Specialist",
  category: "Team",
  image: team3,
  description: "Focused on providing high-quality treatment in a comfortable and supportive environment."
},
{
  id: 23,
  title: "Skilled Dental Practitioner",
  category: "Team",
  image: team4,
  description: "Bringing extensive knowledge and a patient-centered approach to every appointment."
},
{
  id: 24,
  title: "Qualified Oral Health Expert",
  category: "Team",
  image: team5,
  description: "Ensuring safe, effective, and personalized dental solutions for every patient."
},
{
  id: 25,
  title: "Professional Dental Care Provider",
  category: "Team",
  image: team6,
  description: "Delivering comprehensive dental services with integrity and excellence."
},
{
  id: 26,
  title: "Certified Dental Consultant",
  category: "Team",
  image: team7,
  description: "Dedicated to maintaining the highest standards of clinical care and patient satisfaction."
},
{
  id: 27,
  title: "Trusted Dental Associate",
  category: "Team",
  image: team8,
  description: "Committed to promoting long-term oral health through expert guidance and treatment."
},
{
  id: 28,
  title: "Expert in Modern Dentistry",
  category: "Team",
  image: team9,
  description: "Utilizing advanced techniques to provide reliable and effective dental care."
},
{
  id: 29,
  title: "Compassionate Dental Professional",
  category: "Team",
  image: team10,
  description: "Focused on patient comfort while delivering precise and attentive dental services."
},
{
  id: 30,
  title: "Experienced Oral Care Specialist",
  category: "Team",
  image: team11,
  description: "Providing consistent, high-quality dental care tailored to individual patient needs."
},

{
  id: 31,
  title: "Professional Certification",
  category: "Certifications",
  image: Certificate1,
  description: "Official documentation reflecting recognized professional credentials."
},
{
  id: 32,
  title: "Professional Certification",
  category: "Certifications",
  image: Certificate2,
  description: "Recognized certification demonstrating verified professional standing."
},
{
  id: 33,
  title: "Professional Certification",
  category: "Certifications",
  image: Certificate3,
  description: "Formal acknowledgment of established professional qualifications."
},
{
  id: 34,
  title: "Professional Certification",
  category: "Certifications",
  image: Certificate4,
  description: "Authorized credential representing adherence to recognized standards."
},
{
  id: 35,
  title: "Professional Certification",
  category: "Certifications",
  image: Certificate5,
  description: "Validated certification confirming professional recognition."
},
{
  id: 36,
  title: "Professional Certification",
  category: "Certifications",
  image: Certificate6,
  description: "Officially issued document reflecting professional credibility."
},
{
  id: 37,
  title: "Professional Certification",
  category: "Certifications",
  image: Certificate7,
  description: "Recognized professional document demonstrating established credentials."
},
{
  id: 38,
  title: "Professional Certification",
  category: "Certifications",
  image: Certificate8,
  description: "Certified record indicating acknowledged professional status."
},
{
  id: 39,
  title: "Professional Certification",
  category: "Certifications",
  image: Certificate9,
  description: "Formal certificate representing verified professional recognition."
},
{
  id: 40,
  title: "Professional Certification",
  category: "Certifications",
  image: Certificate10,
  description: "Official credential reflecting compliance with recognized professional requirements."
},
{
  id: 41,
  title: "Professional Certification",
  category: "Certifications",
  image: Certificate11,
  description: "Documented certification demonstrating professional authenticity and credibility."
},

  {
  id: 42,
  title: "Media Recognition",
  category: "Press clicks",
  image: Pressclicks1,
  description: "Featured coverage highlighting our professional services and community presence."
},
{
  id: 43,
  title: "Press Coverage",
  category: "Press clicks",
  image: Pressclicks2,
  description: "Published acknowledgment showcasing our commitment to quality dental care."
},
{
  id: 44,
  title: "Media Feature",
  category: "Press clicks",
  image: Pressclicks3,
  description: "Editorial mention recognizing our contributions to the dental field."
},
{
  id: 45,
  title: "Public Recognition",
  category: "Press clicks",
  image: Pressclicks4,
  description: "Documented media appearance reflecting our professional reputation."
},
{
  id: 46,
  title: "Industry Highlight",
  category: "Press clicks",
  image: Pressclicks5,
  description: "Press acknowledgment emphasizing our dedication to patient care."
},
{
  id: 47,
  title: "News Mention",
  category: "Press clicks",
  image: Pressclicks6,
  description: "Media publication featuring our ongoing commitment to excellence."
},
{
  id: 48,
  title: "Editorial Spotlight",
  category: "Press clicks",
  image: Pressclicks7,
  description: "Recognized media spotlight reflecting our trusted professional standing."
},
{
  id: 49,
  title: "Media Appearance",
  category: "Press clicks",
  image: Pressclicks8,
  description: "Official press inclusion highlighting our established presence in the community."
},
{
  id: 50,
  title: "Advanced Laser Procedure",
  category: "Treatments",
  image: treatementsimg3,
  description: "Modern laser-based dental treatment performed with precision and care."
},
{
  id: 51,
  title: "Soft Tissue Laser Therapy",
  category: "Treatments",
  image: treatementsimg4,
  description: "Minimally invasive laser technique designed to enhance treatment accuracy."
},
{
  id: 52,
  title: "Precision Gum Contouring",
  category: "Treatments",
  image: treatementsimg5,
  description: "Laser-assisted procedure focused on improving gum aesthetics and symmetry."
},
{
  id: 53,
  title: "Innovative Dental Laser Care",
  category: "Treatments",
  image: treatementsimg6,
  description: "Advanced technology utilized to support effective and comfortable dental treatment."
},
{
    id: 54,
    title: "Patient Reception Area",
    category: "Clinic",
    image: clinic2,
    description: "A welcoming front-desk space designed to provide comfort and convenience for all visitors.",
  },
  {
    id: 55,
    title: "Clinic Waiting Lounge",
    category: "Clinic",
    image: clinic3,
    description: "A calm and well-appointed seating area ensuring a relaxed experience before appointments.",
  },
  {
  id: 56,
  title: "Advanced Dental Operatory",
  category: "Clinic",
  image: clinic4,
  description: "A clean and ergonomically designed space to ensure high-quality dental procedures.",
  interior: {
    title: "Interior View",
    description: "Comfortable and modern dental operatory with all essential instruments and patient-focused design."
  }
},

  // Add more images as needed (10–30 recommended for gallery)
];

const categories = ["All", "Clinic", "Before/After", "Awards", "Team", "Treatments", "Certifications", "Press clicks"];

const Gallery = () => {
  const [activeCategory, setActiveCategory] = useState("All");
  const [selectedImage, setSelectedImage] = useState(null);

  // Filter images
  const filteredImages = activeCategory === "All"
    ? galleryItems
    : galleryItems.filter(item => item.category === activeCategory);

  return (
    <main className="min-h-screen bg-gray-50">
      {/* Hero / Page Title */}
      <section className="bg-gradient-to-r from-blue-700 to-blue-900 text-white py-16 md:py-24">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 tracking-tight">
            Gallery
          </h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto opacity-90">
            A glimpse into our clinic, treatments, happy patients, and proud moments
          </p>
        </div>
      </section>

      {/* Breadcrumb */}
      {/* <div className="bg-white border-b border-gray-200">
        <div className="container mx-auto px-6 py-4 flex flex-wrap items-center text-sm text-gray-600">
          <Link to="/" className="hover:text-blue-600 transition">Home</Link>
          <span className="mx-2">›</span>
          <span className="text-blue-600 font-medium">Gallery</span>
        </div>
      </div> */}

      {/* Filter Categories */}
      <section className="py-10">
        <div className="container mx-auto px-6">
          <div className="flex flex-wrap justify-center gap-3 md:gap-4">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => setActiveCategory(cat)}
                className={`px-6 py-2.5 rounded-full text-sm md:text-base font-medium transition-all duration-300 ${
                  activeCategory === cat
                    ? "bg-blue-600 text-white shadow-lg scale-105"
                    : "bg-white text-gray-700 hover:bg-gray-100 border border-gray-200 shadow-sm hover:shadow"
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Grid – Masonry style with columns */}
      <section className="pb-20">
        <div className="container mx-auto px-6">
          {filteredImages.length > 0 ? (
            <div className="columns-1 sm:columns-2 lg:columns-3 xl:columns-4 gap-6 space-y-6">
              {filteredImages.map((item) => (
                <div
                  key={item.id}
                  className="group relative break-inside-avoid rounded-2xl overflow-hidden shadow-lg cursor-pointer hover:shadow-2xl transition-all duration-300"
                  onClick={() => setSelectedImage(item)}
                >
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-auto object-cover transform group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />

                  {/* Overlay on hover */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                    <div className="p-6 w-full">
                      <span className="inline-block bg-blue-600 text-white text-xs font-semibold px-3 py-1 rounded-full mb-2">
                        {item.category}
                      </span>
                      <h3 className="text-white text-lg md:text-xl font-bold line-clamp-2">
                        {item.title}
                      </h3>
                      <p className="text-gray-200 text-sm mt-1 line-clamp-2">
                        {item.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-20 text-gray-500 text-xl">
              No images found in this category.
            </div>
          )}
        </div>
      </section>

      {/* Lightbox Modal */}
{selectedImage && (
  <div
    className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
    onClick={() => setSelectedImage(null)}
  >
    <div
      className="relative max-w-5xl w-full max-h-[90vh] flex flex-col items-center"
      onClick={(e) => e.stopPropagation()}
    >
      {/* Close Button */}
      <button
        className="absolute top-4 right-4 bg-black/60 hover:bg-black/80 text-white 
                   w-10 h-10 rounded-full flex items-center justify-center 
                   text-2xl transition backdrop-blur-sm"
        onClick={() => setSelectedImage(null)}
      >
        ×
      </button>

      <img
        src={selectedImage.image}
        alt={selectedImage.title}
        className="max-w-full max-h-[80vh] object-contain mx-auto rounded-lg shadow-2xl"
      />

      <div className="text-white text-center mt-6">
        <h3 className="text-2xl font-bold mb-2">{selectedImage.title}</h3>
        <p className="text-gray-300">{selectedImage.description}</p>
        <span className="inline-block bg-blue-600 px-4 py-1 rounded-full text-sm mt-3">
          {selectedImage.category}
        </span>
      </div>
    </div>
  </div>
)}

    </main>
  );
};

export default Gallery;